import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXMarkSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.337954 0.337954C0.788559 -0.112651 1.51913 -0.112651 1.96974 0.337954L9.66205 8.03026C10.1127 8.48087 10.1127 9.21144 9.66205 9.66205C9.21144 10.1127 8.48087 10.1127 8.03026 9.66205L0.337954 1.96974C-0.112651 1.51913 -0.112651 0.788559 0.337954 0.337954Z",
		fill: "#AAAAAA"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.66205 0.337954C9.21144 -0.112651 8.48087 -0.112651 8.03026 0.337954L0.337954 8.03026C-0.112652 8.48087 -0.112652 9.21144 0.337954 9.66205C0.788558 10.1127 1.51913 10.1127 1.96974 9.66205L9.66205 1.96974C10.1127 1.51913 10.1127 0.788559 9.66205 0.337954Z",
		fill: "#AAAAAA"
	})]
});
export default SvgXMarkSm;
